<template>
    <div id="subNav">
        <div class="level0">
            <ul>
                <template v-for="(item,i) in navList">
                    <li :key="i" :class="{'curr':item.name == '拍卖黄页'}"><a :href="item.url">{{item.name}}</a></li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "subNav",
    data(){
        return{
            navList:[
                {
                    name:'首页',
                    type:'vue',
                    url:'/'
                },
                {
                    name:'拍卖预展',
                    type:'vue',
                    url:'/preauction'
                },
                {
                    name:'拍卖结果',
                    type:'vue',
                    url:'/result'
                },
                // {
                //     name:'拍卖直播',
                //     type:'text',
                //     url:'https://auction.artron.net/live'
                // },
                {
                    name:'拍卖黄页',
                    type: 'text',
                    url:'/brand'
                },
                {
                    name:'雅昌会员',
                    type: 'text',
                    url:'https://member.artron.net/memCenter/collect'
                },
                {
                    name:'得藏',
                    type:'text',
                    url:'https://zxp.artron.net'
                },
                // {
                //     name:'资讯',
                //     type: 'text',
                //     url:'https://auction.artron.net/morenews/list16'
                // },
                // {
                //     name:'对话',
                //     type: 'text',
                //     url:'https://auction.artron.net/column.php'
                // },
                // {
                //     name:'市场',
                //     type: 'text',
                //     url:'https://auction.artron.net/morenews/list577'
                // },
                // {
                //     name:'专题',
                //     type: 'text',
                //     url:'https://auction.artron.net/topic.php'
                // },
                {
                    name:'资讯',
                    type: 'vue',
                    url:'/morenews/16'
                },
                {
                    name:'对话',
                    type: 'vue',
                    url:'/column'
                },
                {
                    name:'市场',
                    type: 'vue',
                    url:'/morenews/577'
                },
                {
                    name:'专题',
                    type: 'vue',
                    url:'/topic'
                }
            ]
        }
    }
}
</script>

<style scoped>
#subNav{width:980px;}
</style>